















































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { Store } from 'vuex';
import { readUserProfile } from '@/store/main/getters';
import CustomSelectInput from '../../components/vui-luma/Ui/CustomSelectInput.vue';
import {FmvBox} from 'fmv-layout';
import PageHeader from '../../components/vui-luma/Ui/PageHeader.vue';
import MdIcon from '../../components/vui-luma/Ui/MdIcon.vue';
import NotificationsManager from '@/components/NotificationsManager.vue';
import PageSeparator from '../../components/vui-luma/Ui/PageSeparator.vue';
import EventCard from '../../components/Events/EventCard.vue';
import {extendMoment} from 'moment-range';
import Moment from 'moment';
import {FmvLineChart} from 'fmv-charts';
import {dispatchGetEvents} from '@/store/events/actions';
import {readEvents} from '@/store/events/getters';
import {
  dispatchGetDashboardLessons,
  dispatchGetNewBook,
} from '@/store/dashboard/actions';
import {readDashboardLessons, readNewBook} from '@/store/dashboard/getters';
import {dispatchGetImportantNews} from '@/store/news/actions';
import {readImportantNews} from '@/store/news/getters';
import {dispatchGetDonationPaymentUrl} from '@/store/subscription/actions';
import DonationModal from '@/components/Team/Modals/DonationModal.vue';
import { api } from '@/api';
import { dispatchGetFreeLessons } from '@/store/courses/actions';
// @ts-ignore
const moment = extendMoment(Moment);

@Component({
  components: {
    NotificationsManager,
    FmvBox,
    PageHeader,
    PageSeparator,
    MdIcon,
    FmvLineChart,
    EventCard,
    CustomSelectInput,
    DonationModal,
  },
})
export default class DashboardAlt extends Vue {
  public containerClass = 'container page__container';
  public donatModalVisible = false;
  public ticketModalVisible = false;
  public donatAmount = 0;
  public ticketType: any = null;
  public ticketText: string = '';
  public freeLessons: any = [];

  public async mounted() {
    await dispatchGetDashboardLessons(this.$store);
    this.freeLessons = await dispatchGetFreeLessons(this.$store);
    // await dispatchGetNewBook(this.$store);
    // await dispatchGetEvents(this.$store);
    // await dispatchGetImportantNews(this.$store);
  }
  get events() {
    return readEvents(this.$store);
  }

  get dashboardLessons() {
    return readDashboardLessons(this.$store);
  }

  get newBook() {
    return readNewBook(this.$store);
  }

  get importantNews() {
    return readImportantNews(this.$store);
  }

  public handleOpenDonationForm() {
    this.donatModalVisible = true;
  }
  public handleCloseDonationModal() {
    this.donatModalVisible = false;
  }

  // public async donateSubmit() {
  //   if (this.donatAmount > 0) {
  //     const data = {
  //       amount: this.donatAmount,
  //       auto_pay: false,
  //     };
  //     const link = await dispatchGetDonationPaymentUrl(this.$store, data);
  //     if (link !== '') {
  //       const element = document.createElement('a');
  //       element.href = link;
  //       setTimeout(() => {
  //         element.click();
  //         }, 200);
  //     }
  //   }
  // }

  public handleChangeType(value) {
    // const newList: any = [];
    // for (const [key, val] of Object.entries(value)) {
    //   // @ts-ignore
    //   newList.push(val.id);
    // }
    this.ticketType = value;
  }

  public async ticketSubmit() {
    const data = {
        type: this.ticketType,
        text: this.ticketText,
    };
    try {
      const response = await api.createTicket(this.$store.getters.token, data);
      // @ts-ignore
      this.showToast(this, this.$t('Ticket created successfuly'));
      this.ticketModalVisible = false;
      this.ticketType = null;
      this.ticketText = '';
    // @ts-ignore
    } catch (e: any) {
      if (e.response && e.response.data.type) {
        // @ts-ignore
        this.showToast(this, e.response.data.type[0], 'error');
      } else if (e.response && e.response.data.text) {
        // @ts-ignore
        this.showToast(this, e.response.data.text[0], 'error');
      } else {
        // @ts-ignore
        this.showToast(this, this.$t('Error'), 'error');
      }
    }
  }

  get userProfile() {
    return readUserProfile(this.$store);
  }
}
